import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VanTransferRoutingModule } from './van-transfer-routing.module';
import {
  NgbAccordionModule,
  NgbTooltipModule,
  NgbDropdownModule,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FeatherModule } from 'angular-feather';
import { VansRoutesComponent } from './vans-routes/vans-routes.component';
import { VansDevicesComponent } from './vans-devices/vans-devices.component';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { GoogleMapsModule } from '@angular/google-maps';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ArchwizardModule } from 'angular-archwizard';
import { ChecklistVanComponent } from './checklist-van/checklist-van.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    VansRoutesComponent,
    VansDevicesComponent,
    ChecklistVanComponent,
  ],
  imports: [
    CommonModule,
    VanTransferRoutingModule,
    NgbAccordionModule,
    MatInputModule,
    FormsModule,
    FeatherModule,
    NgbTooltipModule,
    MatSelectModule,
    NgSelectModule,
    GoogleMapsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    NgbDropdownModule,
    NgbNavModule,
    SharedModule,
    UiSwitchModule.forRoot({
      size: 'small',
    }),
    SharedModule,
    //    ArchwizardModule,
  ],
})
export class VanTransferModule {}
